
import { Vue, Component, Prop } from 'vue-property-decorator';
import NavLogo from '@/features/common/components/navbar/NavLogo.vue';
import AccountStatusCard from '@/features/auth/components/accountStatus/index.vue';

@Component({
  components: {
    AccountStatusCard,
    NavLogo,
  },
})
export default class AccountStatus extends Vue {
  @Prop({ type: String, required: true })
  private readonly i18nKey!: string;
}
